module.exports = __webpack_public_path__ + "static/media/answered.a724ad02.svg";